import {Outlet, useNavigation} from 'react-router-dom';
import {useEffect} from 'react';

import {ShopContext} from './Shop';
import {ShopLocalesAndMarkets} from './ShopLocalesAndMarkets';
import {MonorailProvider as Monorail} from './Monorail/Monorail';

function NavigationLoading() {
  const navigation = useNavigation();

  useEffect(() => {
    if (navigation.state !== 'idle') window.shopify.loading(true);
    return () => window.shopify.loading(false);
  }, [navigation.state]);

  return null;
}

export function RootProviders() {
  return (
    <>
      <NavigationLoading />
      <ShopContext>
        <Monorail>
          <ShopLocalesAndMarkets>
            <Outlet />
          </ShopLocalesAndMarkets>
        </Monorail>
      </ShopContext>
    </>
  );
}
